module.exports = require('iserror')
